import axios from 'axios';
import Qs from 'qs';
import viewUtils from "../utils/viewUtils";
import { getConfig } from '../config/config';
const config = getConfig();

export interface responseData {
  status: boolean;
  data: any;
  error?: any;
  test_error_msg?: any;
  login?: boolean;
  paginate?: any;
}

const initApi = (baseurl) => {
  const API = axios.create({
    baseURL: baseurl,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'authorization': viewUtils.getToken()
    },
    paramsSerializer: {
      serialize: params => Qs.stringify(params, { indices: false }),
    }
    // timeout: 10000,
  });

  API.interceptors.response.use(
    (res): responseData => {
      if(!!res?.data?.login){
        viewUtils.goToLoginPage()
      }
      // status error test_error_msg login data
      return {
        ...res.data,
        status: res.data.status,
      }
    },
    (error): responseData => {
      const status_code = error.response ? error.response.status : 500
      return ({
        code: status_code,
        status: false,
        error: 'Network Error'
      })
    }
  )
  return API;
}

const SERVER_API = initApi(`${config.api_baseurl || ''}`)

export { SERVER_API, initApi }